import * as React from 'react';

import { convertFinishDateToTitleValue } from './utils/convertFinishDateToTitleValue';
import { IHousesByTurn } from '../../types/newbuilding/housesByTurn';
import { TitleValueList } from '../TitleValueList';

interface IHousesByTurnProps {
  housesByTurn: IHousesByTurn[];
}

export function HousesByTurn({ housesByTurn }: IHousesByTurnProps) {
  return (
    <>
      {housesByTurn.map(({ title, finishDates }) => (
        <TitleValueList key={title} title={title} items={convertFinishDateToTitleValue(finishDates)} />
      ))}
    </>
  );
}
